import { useLDClient } from "launchdarkly-react-client-sdk";
import { LD_FLAGS } from "@src/config/launchDarkly";

const useGametimeListingStatusEnabled = (): boolean => {
	const ldClient = useLDClient();
	return ldClient?.variation(LD_FLAGS.gametimeListingStatus, false) ?? false;
};

export default useGametimeListingStatusEnabled;
